import { drawnNumbersSlice } from '@modules/games/Game/store/keno/slices/drawnNumbers.slice';
import { paytablesSlice } from '@modules/games/Game/store/keno/slices/paytables.slice';
import { selectedNumbersSlice } from '@modules/games/Game/store/keno/slices/selectedNumbers.slice';
import { betSummarySlice } from '@modules/games/Game/store/game/slices/betSummary.slice';
import { GameType } from '@modules/games/Game/constants/availableGames';
import { riskSlice } from '@modules/games/Game/store/game/slices/risk.slice';

export const kenoActions = {
	...riskSlice(GameType.KENO).actions,
	...selectedNumbersSlice.actions,
	...drawnNumbersSlice.actions,
	...paytablesSlice.actions,
	...betSummarySlice(GameType.KENO).actions,
};
